import type { NavLink, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'CosmicLens Observatory & Planetarium',
    shortName: 'CosmicLens',
    description: 'A working public observatory on the edge of Exmoor, with a domed planetarium theatre, a rooftop telescope deck and a small research programme. See what is up tonight, book a show or reserve a night under the dome.',
    url: 'https://aphelion-observatory-planetarium.modulify.website',
    hosts: [],
    ogImage: '/images/dome-milky-way.jpg',
    email: 'hello@cosmiclens-observatory.co.uk',
    phone: '01632 960 418',
    social: [
        { label: 'Instagram', href: 'https://www.instagram.com/cosmiclensobservatory', handle: '@cosmiclensobservatory' },
        { label: 'YouTube', href: 'https://www.youtube.com/@cosmiclensobservatory', handle: 'CosmicLens Observatory' },
        { label: 'Bluesky', href: 'https://bsky.app/profile/cosmiclensobservatory.bsky.social', handle: '@cosmiclensobservatory' }
    ]
}

export const primaryNav: NavLink[] = [
    { label: 'Sky Tonight', href: '/sky-tonight' },
    { label: 'Shows', href: '/shows' },
    { label: 'Telescope Nights', href: '/telescope-nights' },
    { label: 'Solar System', href: '/solar-system' },
    { label: 'Research', href: '/research' },
    { label: 'Visit', href: '/visit' }
]

export const secondaryNav: NavLink[] = [
    { label: 'Learn', href: '/learn' },
    { label: 'Catalogue', href: '/catalogue' },
    { label: 'Membership', href: '/membership' }
]

export const bookingLinks = [
    { label: 'Planetarium show', detail: 'Seats under the dome, from £9', href: '/shows' },
    { label: 'Telescope night', detail: 'Small groups on the roof, from £24', href: '/telescope-nights' },
    { label: 'Membership', detail: 'Priority booking and members-only nights', href: '/membership' }
]
